export default `Canny('identify', {
  appID: 'YOUR_APP_ID',
  user: {
    avatarURL: viewer.avatarURL, // optional
    companies: viewer.companies.map((company) => ({
      created: new Date(company.created).toISOString(), // optional
      customFields: {
        companyType: 'b2b',
        employees: 100,
        industry: 'technology',
      },
      id: company.id,
      monthlySpend: company.monthlySpend, // optional, the MRR for the company in dollars. This will be rounded to two decimal places.
      name: company.name,
    })),
    created: new Date(viewer.created).toISOString(), // optional
    customFields: {
      title: 'Product Manager',
    },
    email: viewer.email,
    id: viewer.id,
    name: viewer.name,
  },
});`;
